import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "../../../../../../base/components/base.component";
import {EventBusService} from "../../../../../../base/services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../base/services/subscription-container.service";
import {UserService} from "../../../auth/services/user.service";
import {UserSlice} from "../../../auth/models/user.model";
import {EventKey} from "../../../../../../registry/event.key";
import {TextUtility} from "../../text.utility";
import {IParams} from "../../../../../../base/endpoints/iparams";

@Component({
  selector: 'app-user-filter',
  templateUrl: './user-filter.component.html',
  styleUrls: ['./user-filter.component.scss']
})
export class UserFilterComponent extends BaseComponent {

  users: UserSlice[] = []
  @Input() username: string | null = null

  @Output() selected: EventEmitter<string | null> = new EventEmitter<string | null>()

  protected componentName(): string {
    return UserFilterComponent.name;
  }

  constructor(eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
              private userService: UserService,) {
    super(eventBus, router, subContainer)
  }

  ngOnInit(): void {
    this.loading = false
    this.searchUsers({
      page: 0,
      size: 10,
      q: null,
      slice: true
    })
  }

  onUserSelected(event: any) {
    this.selected.emit(this.username)
  }

  searchUsersForEvent(event: any) {
    let query = TextUtility.removeSpecialCharacters(event.target?.value)
    if (query.length > 2) {
      this.searchUsers({
        page: 0,
        size: 10,
        q: query,
        slice: true
      })
    }
  }

  searchUsers(params: IParams) {
    this.loading = true
    let key = this.componentKey(EventKey.USERS.SEARCH_USERS())
    this.userService.searchUsers(key, params)
    this.subscribe(key, null, (value, meta) => {
      this.users = meta.data.content
      this.loading = false
    })
  }

}
